export default "__VITE_ASSET__3d433508__"